import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AGENCY } from "../data/content";

export default function Datenschutz() {
  return (
    <main className="min-h-screen bg-[#101318] py-24 px-6 md:px-12" data-testid="datenschutz-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-bold text-[#2E5BFF] hover:text-white transition-colors mb-10" data-testid="datenschutz-back-link">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Datenschutzerklärung</h1>
        <div className="mt-10 space-y-8 text-[#9AA3AF] leading-relaxed">
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">1. Verantwortlicher</h2>
            <p>
              {AGENCY.name}, Inhaber: {AGENCY.founder}, {AGENCY.region}<br />
              E-Mail: {AGENCY.email}<br />
              [Vollständige Anschrift wird ergänzt]
            </p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">2. Erhebung und Verarbeitung von Daten</h2>
            <p>
              Beim Besuch dieser Website werden nur die Daten verarbeitet, die technisch erforderlich sind, um Ihnen
              die Seite anzuzeigen. Personenbezogene Daten (Name, Firma, Telefonnummer, E-Mail-Adresse, Website-URL)
              werden nur dann erhoben, wenn Sie uns diese über das Kontaktformular freiwillig mitteilen. Diese Daten
              verwenden wir ausschließlich zur Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b DSGVO).
            </p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">3. Cookies</h2>
            <p>
              Diese Website verwendet nur technisch notwendige Cookies bzw. lokale Speicherung (z. B. zum Speichern
              Ihrer Cookie-Auswahl). Statistik-Dienste werden erst nach Ihrer ausdrücklichen Einwilligung geladen
              (Art. 6 Abs. 1 lit. a DSGVO). Ihre Auswahl können Sie jederzeit über den Link
              &bdquo;Cookie-Einstellungen&ldquo; im Footer ändern.
            </p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">4. Ihre Rechte</h2>
            <p>
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
              Datenübertragbarkeit sowie Widerspruch. Wenden Sie sich hierzu an die oben genannten Kontaktdaten.
              Zudem besteht ein Beschwerderecht bei der zuständigen Datenschutz-Aufsichtsbehörde.
            </p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">5. Speicherdauer</h2>
            <p>
              Anfragedaten werden gelöscht, sobald sie für die Bearbeitung nicht mehr erforderlich sind und keine
              gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
